import {ADD_TO_CART,  REMOVE_FROM_CART, UPDATE_QUANTITY} from '../actionConstants';

export const addToCart = product => async dispatch => {
  dispatch({
    type: ADD_TO_CART,
    payload:product,
  });
};

export const removeFromCart = ({productId, size}) => {
  return {
    type: REMOVE_FROM_CART,
    payload: {productId, size},
  };
};

export const updateQuantity = ({productId, size, quantity}) => {
  return {
    type: UPDATE_QUANTITY,
    payload: {productId, size, quantity},
  };
};
